import React from 'react';
import classNames from '~/components/util/classNames';

export default ({
    headerTxt = '',
    children,
    className
}) => (
    <div className="mb-6 mt-1 pt-2 pb-2">
        <div className={classNames('card-header', className)}>
            <div className="row">
                <div className={children ? 'col-6 t-nowrap m-auto' : 'col mr-auto'}>
                    <h1 className={classNames('display-3 text-xl font-semibold', className)}>{headerTxt}</h1>
                </div>
                {children && (
                    <div className="col-6 d-flex justify-content-end align-items-center">{children}</div>
                )}
            </div>
        </div>
    </div>

    
);
